import onReady from 'Common/core/onReady';

class CardGrid {
    constructor(root) {
        this.root = root;
        this.handleClick = this.handleClick.bind(this);

        this.root.addEventListener('click', this.handleClick);
    }

    handleClick(event) {
        const link = event.target.closest('a[data-link-type]');

        if (!link || !this.root.contains(link)) return;

        const linkType = (link.dataset.linkType || 'Page').toLowerCase();

        if (linkType !== 'video') return;

        const videoUrl = link.getAttribute('href');

        if (!videoUrl) return;

        event.preventDefault();
        event.stopPropagation();
        this.openVideoModal(videoUrl);
    }

    openVideoModal(videoUrl) {
        const componentFactory = window.components && window.components.VideoPlayerModal;

        if (typeof componentFactory !== 'function') {
            window.location.assign(videoUrl);
            return;
        }

        const videoContainer = document.createElement('div');

        document.body.append(videoContainer);
        componentFactory(videoContainer, {
            videoProps: {
                url: videoUrl,
                playing: true,
            },
            show: true,
            onClose: function onClose() {
                videoContainer.remove();
            },
        });
    }
}

export default function cardGrid() {
    onReady(() => {
        document.querySelectorAll('.card-grid[data-card-grid]').forEach((root) => {
            if (root.dataset.cardGridInitialized === 'true') return;

            root.dataset.cardGridInitialized = 'true';
            new CardGrid(root);
        });
    });
}

